import "./App.css";
import RouteManager from "./utils/RouteManager";

function App() {
  return (
    <>
      <div className="div min-h-[70vh] h-auto 5xl">
        <RouteManager />
      </div>
    </>
  );
}

export default App;
